import { styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

import { useAllowedApps } from '@verantos-dev/core-auth';
import { getUrlForSidebarAppId } from '@verantos-dev/shared-layout';

const LandingPageContainer = styled('div')({
  backgroundImage: "url('./images/verantos-background.png')",
  backgroundColor: '#035b7f',
  height: '100%',
  backgroundSize: 'cover',
});

const StyledLandingPage = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#fff',
  flexDirection: 'column',
});

const LandingPageMessage = styled('div')({
  fontSize: '28px',
  lineHeight: '48px',
});

export const LandingPage = () => {
  const intl = useIntl();
  let message;
  const apps = useAllowedApps();

  if (apps.length === 0) {
    message = intl.formatMessage({ id: 'authenticatedPage.noAccessMessage' });
  }

  return (
    <LandingPageContainer data-testid="landing-page">
      <StyledLandingPage>
        {apps.length ? (
          <Navigate to={getUrlForSidebarAppId(apps[0].appId)} replace={true} />
        ) : (
          <LandingPageMessage>{message}</LandingPageMessage>
        )}
      </StyledLandingPage>
    </LandingPageContainer>
  );
};

export default LandingPage;
